export const initStateSet1 = [
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/erlang.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/phoenix.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/python.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/sass.png",
  },

  {
    img: "https://invozone.com/wp-content/uploads/2020/06/php.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/laravel.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/react.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/AngularJs.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/elastic.png",
  },
];

export const initStateSet2 = [
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/MongoDB.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/html.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/elixer.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/aws.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/googleCloud.png",
  },

  {
    img: "https://invozone.com/wp-content/uploads/2020/06/bigQuery.png",
  },

  {
    img: "https://invozone.com/wp-content/uploads/2020/06/postgreSQL.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/VueJs.png",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/circleci.png",
  },
];
